@import '~@splidejs/splide/dist/css/splide.min.css';

/* stylelint-disable selector-class-pattern */
sew-ws-news-feed {
    @include grid;

    &:not([no-margin]) {
        @include component-spacing;
    }

    h2,
    sew-ws-link {
        grid-row: 1;
    }

    h2 {
        @include typo-ws-h2;

        grid-column: 2 / span 8;
        margin: 0;
    }

    sew-ws-link {
        grid-column: 10 / span 4;
        justify-self: end;
        margin-right: -12px;
        margin-top: 16px;
    }

    .splide {
        grid-column: 2 / span 12;
        grid-row: 2;
        margin-top: 36px;
    }

    .splide__arrow {
        background: transparent;
        top: calc(var(--image-height) / 2);
        transform: translateY(-50%) scale(1.5);

        svg {
            color: $color-grey-01-dark;
            height: 40px;
            opacity: 0.4;
            width: 100%;
        }
    }

    .splide__arrow--next {
        right: -52px;
    }

    .splide__arrow--prev {
        left: -52px;
    }

    .news-pagination {
        align-items: flex-end;
        margin-top: 32px;
        position: relative;
        column-gap: 10px;

        li {
            line-height: 10px !important;
            width: 10px;
            height: 10px;
            overflow: hidden;
        }
    }

    .news-page {
        background: $color-grey-04-middle;
        border-radius: 0;
        cursor: pointer;
        height: 40px;
        margin: 0;
        opacity: 1;
        width: 40px;

        &.is-active {
            background: $color-red;
            transform: scale(1);
        }
    }
}

@include mq-2 {
    sew-ws-news-feed {
        .splide__arrow--next {
            right: -32px;
        }

        .splide__arrow--prev {
            left: -32px;
        }
    }
}

@include mq-1 {
    sew-ws-news-feed {
        h2,
        sew-ws-link {
            grid-column: 2 / span 12;
        }

        sew-ws-link {
            grid-row: 2;
            justify-self: start;
            margin: 24px 0 0;
        }

        .splide {
            grid-row: 3;
            margin-top: 24px;
        }
    }
}
/* stylelint-enable selector-class-pattern */
